export const componentsEs = {
  headerNabvar: {
    es: {
      alt: 'Español',
      url: 'es.svg'
    },
    en:  {
      alt: 'English',
      url: 'gb.svg'
    }
  },
  fantasyNavbar: [
    {
      title: 'Dashboard',
      link: '/home',
      icon: 'mdi-view-dashboard'
    },
    {
      title: 'Fantasy',
      link: '/fantasy',
      icon: 'mdi-trophy',
      children: [
       /* {
          title: 'Inicio',
          link: '/fantasy/home',
          icon: 'mdi-home',
        },*/
        {
          title: 'Competiciones',
          link: '/fantasy/competitions',
          icon: 'mdi-soccer-field',
        },
        {
          title: 'Jornadas',
          link: '/fantasy/matchsets',
          icon: 'mdi-calendar',
        },
        {
          title: 'Partidos',
          link: '/fantasy/matches',
          icon: 'mdi-whistle',
        },
        {
          title: 'Equipos',
          link: '/fantasy/teams',
          icon: 'mdi-account-group-outline',
        },
        {
          title: 'Jugadores',
          link: '/fantasy/players',
          icon: 'mdi-account-details-outline',
        },
        {
          title: 'Campeonatos',
          link: '/fantasy/contests',
          icon: 'mdi-crown',
        },
        {
          title: 'Redes',
          link: '/fantasy/networks',
          icon: 'mdi-lan',
        },
        {
          title: 'Categorías',
          link: '/fantasy/categories',
          icon: 'mdi-table-large',
        },
      ]
    },
    {
      title: 'Casino',
      link: '/casino',
      icon: 'mdi-ferris-wheel',
      children: [
        /* {
           title: 'Home',
           link: '/fantasy/home',
           icon: 'mdi-home',
         },*/
        {
          title: 'RTP',
          link: '/casino/rtp',
          icon: 'mdi-account-arrow-left',
        },
        {
          title: 'Rounds',
          link: '/casino/rounds',
          icon: 'mdi-calendar-star'
        },
        {
          title: 'Lobby',
          link: '/casino/lobby',
          icon: 'mdi-file-tree'
        },
      ]
    },
    {
      title: 'Campañas',
      link: '/campaigns',
      icon: 'mdi-diamond-stone',
      children: [
        {
          title: 'Freespins',
          link: '/campaigns/freespins',
          icon: 'mdi-gift-outline'
        },
        {
          title: 'FreeRounds',
          link: '/campaigns/freerounds',
          icon: 'mdi-decagram-outline'
        },
        {
          title: 'Opt-in',
          link: '/campaigns/optin',
          icon: 'mdi-check-decagram'
        },
        {
          title: 'Refer a friend',
          link: '/campaigns/referafriend',
          icon: 'mdi-account-multiple-plus'
        },
      ]
    },
    {
      title: 'Administradores',
      link: '/administrators',
      icon: 'mdi-account-star-outline'
    },
    {
      title: 'Usuarios',
      link: '/users',
      icon: 'mdi-account-box-multiple'
    },
    {
      title: 'Juegos',
      link: '/games',
      icon: 'mdi-gamepad'
    },
    {
      title: 'Proveedores',
      link: '/providers',
      icon: 'mdi-google-controller',
    },
    {
      title:'Operadores',
      link: '/operators',
      icon: 'mdi-poker-chip',
    },
    {
      title:'Finanzas',
      link: '/finances',
      icon: 'mdi-finance',
    },
    // {
    //   title:'Torneos',
    //   link: '/tournaments',
    //   icon: 'mdi-tournament'
    // }
  ],
  token: {
    title: 'Aviso: cierre de sesión',
    text: 'La sesión va a expirar. Se cerrará automáticamente en unos segundos.',
    button: {
      refresh: 'actualizar',
    },
  },
  basePasswordField: {
    repeatpassword: 'La contraseña no coincide',
  },
  loginCard: {
    username: {
      label: 'Nombre de usuario',
      name: 'username',
      icon: 'mdi-account'
    },
    password: {
      label: 'Contraseña',
      name: 'password',
      icon: 'mdi-lock'
    },
    pin: {
      label: 'Pin',
      name: 'pin',
      icon: 'mdi-email-lock'
    },
    infoPin: 'Se le ha enviado el pin por email. Por favor, revise su correo.',
    submitUserText: 'Acceder',
    submitPinText: 'Confirmar'
  },
  playerCompetitionInfoDialog: {
    buttonText: 'Ver Estadísticas',
    title: 'Puntos y Valor de: ',
    table: {
      competition: 'Campeonato',
      team: 'Equipo',
      points: 'Puntos',
      value: 'Valor',
    }
  },
  providerInfoDialog: {
    title: 'Info del proveedor',
  },
  operatorProvidersInfoDialog: {
    notFound: 'Este operador no tiene proveedores',
    tablehead: {
      provider: 'Provider',
    },
    label: {
      ggr: 'GGR',
      invoice: {
        name: 'Nombre',
        address: 'Dirección',
        vat: 'VAT number',
        tax: 'Tax',
        phone: 'Teléfono',
        email: 'Email',
      },
    },
  },
  gamesInfoDialog:{
    name: 'Nombre',
    alias: 'Alias',
    type:'Tipo',
    jurisdictions:'Jurisdicciones',
    providers:'Proveedor',
    key:'Launch ID',
    button:'Ver Info'
  },
  MatchsetInfoDialog: {
    headers: {
      tabs: {
        players: 'Jugadores',
        matches: 'Partidos',
      },
      playersTable: {
        name: 'Nombre',
        team: 'Equipo',
        role: 'Posición',
        value: 'Valor',
      },
      matchesTable: {
        date: 'Fecha',
        teamhome: 'Equipo Local',
        score: 'Marcador',
        teamaway: 'Equipo Visitante',
        state: 'Estado',
      },
    },
  },
  roundInfoDialog:{
    title: 'Información de Round',
    roundId: 'Round ID',
    operator: 'Operador',
    provider:'Proveedor',
    game:'Juego',
    moneyIn:'Dinero in',
    moneyOut:'Dinero out',
    user:'Usuario',
    status:'Estado',
    start:'Comienzo'
  },
  transactionInfoDialog: {
    title: 'Transacciones',
    status: 'Estado',
    created: 'Fecha transacción',
    externalReference: 'Referencia Externa',
    type:'Tipo',
    amount:'Cantidad',
    bonusAmount:'Cantidad Bonus',
    empty: 'No hay Transacciones'
  },
  ChangePasswordDialog: {
    title: 'Cambiar contraseña',
    label: {
      oldpassword: 'Contraseña actual',
      password: 'Nueva contraseña',
      repeatpassword: 'Repita nueva contraseña',
    },
    button: 'Cambiar',
  },
  balanceCard: {
    noResults: 'No se han encontrado resultados',
  },
  pagination: {
    text: 'Elementos por página:',
  },
  categoryInfoCard: {
    title: 'Información de:',
    empty: 'Esta categoría no tiene niveles.',
    name: 'Nombre',
    level: 'Nivel',
    points: 'Puntos',
    rollDown: 'Roll Down',
    percentage: 'Porcentaje',
    button: 'Ver Info'
  },
  baseDynamicField: {
    button: {
      remove: 'Borrar',
      add: 'Añadir',
    },
    label: {
      key: 'Nueva clave',
      value: 'Nuevo valor'
    },
    advise: 'Recuerde que el campo no se genera hasta pulsar el botón de añadir',
    dialog: {
      title: 'Aviso',
      textempty: 'Debe añadir un nombre al campo.',
      textrepeat: 'Este campo está repetido.',
      button: 'Aceptar',
    },
  },
  baseDynamicLevel: {
    button: {
      remove: 'Borrar',
      add: 'Añadir',
    },
    dialog: {
      title: 'Aviso',
      advise: {
        points: 'Cada valor de puntos debe ser menor al anterior nivel',
        percentage: 'Todos los porcentajes deben sumar 100',
      },
      button: 'Aceptar',
    },
  },
  baseFieldsGenerator: {
    resume: 'Resumen de campos añadidos:',
    newfield: 'Nuevo Campo:',
    add: 'Añadir',
  },
  baseInvoiceItemsField: {
    button: {
      remove: 'Borrar',
      add: 'Añadir',
    },
    label: {
      no: 'No.',
      description: 'Descripción',
      qty: 'Qty',
      price: 'Precio',
      discount: 'Descuento %',
      tax: 'Tax %',
      total: 'Total',
    },
    dialog: {
      title: 'Aviso',
      text: 'Debe añadir una descripción, una cantidad y un precio',
      button: 'Aceptar',
    },
  },
  operatorProviderEditDialog:{
    label: {
      key1: 'Clave',
      key2: 'Clave secundaria',
      key3: 'Clave terciaria',
      launcher: 'Lanzador',
      api: 'API',
      ggr: 'ggr',
      cap: 'Bonus cap',
      extrafields: 'Campos adicionales',
    },
    button:{
      edit: 'Editar',
    },
  },
};
